import * as React from "react"

export const UserCompaniesPage = () => (
    <p>UserCompaniesPage</p>
)
